import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { SalesDetail } from '../models/sales/sales-detail';
import { SaleFilter } from './../models/sales/sale-filter.model';
import { KeyValuePair } from './../models/sales/key-value-pair';
import { SaleDisplacement } from './../models/sales/sale-displacment.model';
import { SalesSoukou } from './../models/sales/sales-soukou.model';

import { apiUrl } from '../app.config';

import 'rxjs/add/operator/map';
import { Router } from '@angular/router';
import { DataService } from './data.service';

@Injectable()
export class SalesService {
  makerData = [
    {
      id: 'maker01',
      name: 'レクサス',
      image: '/assets/sales/images/maker/01100.jpg'
    },
    {
      id: 'maker02',
      name: 'トヨタ',
      image: '/assets/sales/images/maker/00100.jpg'
    },
    {
      id: 'maker03',
      name: '日産',
      image: '/assets/sales/images/maker/00200.jpg'
    },
    {
      id: 'maker04',
      name: 'ホンダ',
      image: '/assets/sales/images/maker/00300.jpg'
    },
    {
      id: 'maker05',
      name: 'マツダ',
      image: '/assets/sales/images/maker/00400.jpg'
    },
    {
      id: 'maker06',
      name: 'ミツビシ',
      image: '/assets/sales/images/maker/00500.jpg'
    },
    {
      id: 'maker07',
      name: 'スバル',
      image: '/assets/sales/images/maker/00600.jpg'
    },
    {
      id: 'maker08',
      name: 'ダイハツ',
      image: '/assets/sales/images/maker/00800.jpg'
    },
    {
      id: 'maker09',
      name: 'スズキ',
      image: '/assets/sales/images/maker/00900.jpg'
    }
  ];

  modelData = [
    {
      id: 'CT',
      name: 'CT'
    },
    {
      id: 'CT200H',
      name: 'CT200H'
    },
    {
      id: 'GS',
      name: 'GS'
    },
    {
      id: 'HS',
      name: 'HS'
    }
  ];

  bodyData = [
    {
      id: 'bd01',
      name: '軽自動車',
      image: '/assets/sales/images/bodytype/01.png'
    },
    {
      id: 'bd02',
      name: '軽トラック',
      image: '/assets/sales/images/bodytype/02.png'
    },
    {
      id: 'bd03',
      name: 'コンパクト',
      image: '/assets/sales/images/bodytype/03.png'
    },
    {
      id: 'bd04',
      name: 'セダン',
      image: '/assets/sales/images/bodytype/04.png'
    },
    {
      id: 'bd05',
      name: 'SUV・クロカン',
      image: '/assets/sales/images/bodytype/05.png'
    },
    {
      id: 'bd06',
      name: 'ミニバン',
      image: '/assets/sales/images/bodytype/06.png'
    },
    {
      id: 'bd07',
      name: 'ステーションワゴン',
      image: '/assets/sales/images/bodytype/07.png'
    },
    {
      id: 'bd08',
      name: 'クーペ',
      image: '/assets/sales/images/bodytype/08.png'
    },
    {
      id: 'bd09',
      name: 'オープン',
      image: '/assets/sales/images/bodytype/09.png'
    },
    {
      id: 'bd10',
      name: 'トラック',
      image: '/assets/sales/images/bodytype/10.png'
    },
    {
      id: 'bd11',
      name: 'バン',
      image: '/assets/sales/images/bodytype/11.png'
    },
    {
      id: 'bd12',
      name: 'ハイブリッド',
      image: '/assets/sales/images/bodytype/12.png'
    }
  ];

  // pulldown
  first = [
    {
      display: 'H29(2017)年',
      value: '2017',
      name: '年式'
    },
    {
      display: 'H28(2016)年',
      value: '2016',
      name: '年式'
    },
    {
      display: 'H27(2015)年',
      value: '2015',
      name: '年式'
    }
  ];

  rating = [
    {
      display: 'S',
      value: 'S',
      name: '距離'
    },
    {
      display: '6',
      value: '6',
      name: '距離'
    },
    {
      display: '5',
      value: '5',
      name: '距離'
    }
  ];

  soukou = [
    {
      display: '1,000km',
      value: '1,000km',
      name: '評価'
    },
    {
      display: '2000km',
      value: '2,000km',
      name: '評価'
    },
    {
      display: '3000km',
      value: '3,000km',
      name: '評価'
    }
  ];

  salesListFilter: SaleFilter = {
    pageSize: 25,
    currentPage: 1,
    color: [],
    displacement: {
      start: null,
      end: null
    },
    price: [],
    rating: [],
    shaken: [],
    soukou: [],
    stock: []
  };

  static headers = new Headers({ 'Content-Type': 'application/json' });

  private url = 'https://carstamate.firebaseio.com/salelist.json';

  constructor(private http: Http, private router: Router, private _data: DataService) {}

  getMakerData() {
    return this.makerData;
  }

  getModelData() {
    return this.modelData;
  }

  getBodyData() {
    return this.bodyData;
  }

  getFirst() {
    return this.first;
  }

  getRating() {
    return this.rating;
  }

  getSoukou() {
    return this.soukou;
  }

  getSalesList() {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http
      .get(this.url)
      .map(res => res.json())
      .catch(this.handleError.bind(this));
  }

  getSaleDetail(): Observable<SalesDetail> {
    return this.http
      .get(`https://carstamate.firebaseio.com/saledetail.json`, {
        headers: SalesService.headers
      })
      .map(response => new SalesDetail(response.json()));
  }

  getSalesFilterProp(type: any) {
    //return this.salesListFilter[type];
    if (type == 'price') {
      return this.salesListFilter['price'];
    } else if (type == 'rating') {
      return this.salesListFilter['rating'];
    } else if (type == 'shaken') {
      return this.salesListFilter['shaken'];
    } else if (type == 'soukou') {
      return this.salesListFilter['soukou'];
    } else if (type == 'stock') {
      return this.salesListFilter['stock'];
    }
    return [];
  }

  setSalesDisplacement(data: any) {
    this.salesListFilter.displacement = data;
  }

  setSalesListFilter(data: KeyValuePair[], type: string) {
    if (type == 'price') {
      this.salesListFilter['price'] = data;
    } else if (type == 'rating') {
      this.salesListFilter['price'] = data;
    } else if (type == 'shaken') {
      this.salesListFilter['shaken'] = data;
    } else if (type == 'soukou') {
      this.salesListFilter['soukou'] = data;
    } else if (type == 'stock') {
      this.salesListFilter['stock'] = data;
    }
  }

  getColor(): Observable<KeyValuePair[]> {
    const headers = SalesService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(`${apiUrl}/stocks/search/conditions/color`, {
        headers: SalesService.headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getDisplacement(): Observable<SaleDisplacement> {
    const headers = SalesService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(`${apiUrl}/stocks/search/conditions/displacement`, {
        headers: SalesService.headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getPrice(): Observable<KeyValuePair[]> {
    const headers = SalesService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(`${apiUrl}/stocks/search/conditions/price`, {
        headers: SalesService.headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getRating1(): Observable<any> {
    const headers = SalesService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(`${apiUrl}/stocks/search/conditions/rating`, {
        headers: SalesService.headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getShaken(): Observable<KeyValuePair[]> {
    const headers = SalesService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(`${apiUrl}/stocks/search/conditions/shaken`, {
        headers: SalesService.headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getStockKbn(): Observable<KeyValuePair[]> {
    const headers = SalesService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(`${apiUrl}/stocks/search/conditions/stockKbn`, {
        headers: SalesService.headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getSoukou1(): Observable<Array<SalesSoukou>> {
    const headers = SalesService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(`${apiUrl}/stocks/search/conditions/soukou`, {
        headers: SalesService.headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  private handleError(error: any | any) {
    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(error.json());
    }
  }

  deleteToken() {
    const headerParams = SalesService.headers;
    headerParams.set('auth', this._data.token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this.http
        .delete(`${apiUrl}/auth/token`, { headers: SalesService.headers })
        .subscribe(() => {});
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sales.service.ts